// extracted by mini-css-extract-plugin
export default {"container":"sCySz9","navigation":"A9gOc4","homeLink":"F6A1Pp"};